// src/api/povinnostiApi.js

// Tu budú všetky API volania a operácie so serverom pre Povinnosti

export async function saveTasks(userPin, tasks) {
  try {
    const resp = await fetch(`/php/tasks_api.php?action=save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin: userPin, tasks })
    });
    const text = await resp.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
    if (!resp.ok) {
      return {
        ok: false,
        error: data?.error || `HTTP ${resp.status}: ${text.slice(0, 200)}`,
        safetyCheck: data?.safety_check === true
      };
    }
    if (data?.error) return { ok: false, error: data.error };
    if (!data || data.success !== true) {
      return { ok: false, error: "Server nepotvrdil uloženie úloh." };
    }
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

export async function updateTask(userPin, task) {
  // Aktualizácia jedného tasku v databáze (bez prepisu celej tabuľky)
  try {
    const resp = await fetch(`/php/tasks_api.php?action=update_task`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin: userPin, task })
    });
    if (!resp.ok) throw new Error("Chyba aktualizácie úlohy");
    const data = await resp.json();
    if (data && data.error) throw new Error(data.error);
    return true;
  } catch (e) {
    return false;
  }
}

export async function loadTasks(userPin) {
  // Načítanie úloh zo servera cez PHP API (rovnaká logika ako predtým)
  const resp = await fetch(`/php/tasks_api.php?action=load&pin=${encodeURIComponent(userPin)}`);
  const text = await resp.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error(`Neplatná odpoveď servera: ${text.slice(0, 200)}`);
  }
  if (!resp.ok) {
    throw new Error(data?.error || `HTTP ${resp.status}`);
  }
  if (Array.isArray(data)) return data;
  if (data?.error) throw new Error(data.error);
  throw new Error("Server vrátil neplatný zoznam úloh");
}

export async function uploadAttachment(taskId, file, userPin) {
  // ... sem príde fetch na upload prílohy ...
}

export async function deleteAttachment(taskId, attachmentId, userPin) {
  // ... sem príde fetch na zmazanie prílohy ...
}

// Pridaj ďalšie API funkcie podľa potreby
